// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"176b7f1f","271":"176b7f1f","408":"2352ff27","498":"f6931f75","752":"ad3afefa","928":"6f3674b5"}[chunkId] + ".chunk.css";
};